import HighLightWords from "@dropDesk/presentation/components/high_light_words";
import React, {useEffect} from "react";
import {useInjection} from "inversify-react";
import {observer} from "mobx-react";
import SelectSearchRemote from "@dropDesk/presentation/components/inputs/select_search_remote";
import {ConstantsKeys} from "@dropDesk/domain/entities/constants/constants_keys";
import {Select} from "antd";
import {
    ContainerColumn,
    ContainerHeaderColumn,
    ContainerHeaderText,
    ContentColumn,
    TextMainEllipsis,
} from "./styled";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {setBlockUpdateLocalSearchCache} from "@dropDesk/utils/helpers/common";
import {
    SelectSearchSearchClientType
} from "@dropDesk/presentation/components/inputs/select_search_clients/select_search_clients";
import {ClientController} from "@dropDesk/presentation/pages/client/controller/client.controller";
import AvatarImage from "@dropDesk/presentation/components/avatar";
import {setMaskCnpj, setMaskCpf} from "@dropDesk/presentation/components/inputs/input_with_border/masks";
import {isValidCNPJ} from "@dropDesk/utils/helpers/validators";
import {ClientEntity} from "@dropDesk/domain/entities/client/client.entity";

const {Option} = Select;
const SelectSearchClient = observer((props: SelectSearchSearchClientType) => {

    const clientController = useInjection(ClientController);
    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;

    useEffect(() => {
        initialize();
    }, []);

    const initialize = () => {
        clientController.tableClients.limit = ConstantsKeys.defaultLimitSelectSearchItems;
    }

    const onSearch = (searchParam: string): void => {
        setBlockUpdateLocalSearchCache(true);
        clientController.list(searchParam);
    }

    const itemWidth = 200;

    const getDocumentText = (document?: string | null): string => {
        if (document) {
            if (isValidCNPJ(document)) {
                return setMaskCnpj(document);
            }
            return setMaskCpf(document);
        }
        return document ?? '';
    }

    const options =
        <>
            {clientController.tableClients.data.map(client => (
                <Option key={client.id} value={client.id} label={client.name} data={client}>
                    <ContainerColumn>
                        <ContentColumn width={itemWidth}>
                            <AvatarImage
                                useCursorPointer={!!client.urlImageProfile}
                                title={client.name}
                                size={25}
                                url={client.urlImageProfile ?? ''}
                                round={true}
                                withBorder={true}
                                hasPreviewImage={false}
                            />
                            <TextMainEllipsis style={{marginLeft: 5}}>
                                <HighLightWords
                                    searchWords={clientController.searchParam}
                                    textToHighlight={client.socialName}
                                    fontSize={13}
                                />
                            </TextMainEllipsis>
                        </ContentColumn>
                        <ContentColumn width={itemWidth}>
                            <TextMainEllipsis>
                                <HighLightWords
                                    searchWords={clientController.searchParam}
                                    textToHighlight={client.name ?? ''}
                                    fontSize={13}
                                />
                            </TextMainEllipsis>
                        </ContentColumn>
                        <ContentColumn width={itemWidth}>
                            <TextMainEllipsis>
                                <HighLightWords
                                    searchWords={clientController.searchParam}
                                    textToHighlight={getDocumentText(client.document)}
                                    fontSize={13}
                                />
                            </TextMainEllipsis>
                        </ContentColumn>
                    </ContainerColumn>
                </Option>
            ))}
        </>;
    const optionsHeader =
        <ContainerHeaderColumn>
            <ContainerHeaderText color={colors.hintInverse} width={itemWidth}>Nome</ContainerHeaderText>
            <ContainerHeaderText color={colors.hintInverse} width={itemWidth}>Nome Fantasia</ContainerHeaderText>
            <ContainerHeaderText color={colors.hintInverse} width={itemWidth}>CNPJ/CPF</ContainerHeaderText>
        </ContainerHeaderColumn>


    return (
        <SelectSearchRemote<ClientEntity>
            onChange={(filter, client) => {
                props.handleSelectClient(filter, client);
            }}
            onClickRemoveFilter={() => {
                clientController.tableClients.page = 0;
            }}
            disabled={props.disabled}
            onSearch={(value) => onSearch(value)}
            size={props.size}
            useRemoveFilter={props.useRemoveFilter}
            width={props.width}
            widthPopup={props.widthPopup ?? 632}
            label={props.label}
            placeHolder={props.placeHolder}
            value={props.value}
            loading={clientController.loading}
            options={options}
            optionsLength={clientController.tableClients.data.length}
            search={true}
            searchValue={clientController.searchParam}
            hasMore={clientController.tableClients.hasMore}
            loadMore={() => clientController.loadMoreDataFromPage()}
            messageError={props.messageError}
            required={props.required}
            onClickButtonRight={props.onClickButtonRight}
            labelButtonRight={props.labelButtonRight}
            nameIconButtonRight={props.nameIconButtonRight}
            tooltipButtonRight={props.tooltipButtonRight}
            disabledButtonRight={props.disabledButtonRight}
            useButtonRight={props.useButtonRight}
            iconLeftName={props.iconLeftName}
            borderColor={props.borderColor}
            dropdownRender={menu => (
                <>
                    {optionsHeader}
                    {menu}
                </>
            )}
        />
    )
});
export default SelectSearchClient;
